module.exports = __webpack_public_path__ + "static/img/img0-map.aed75c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards/img0-map.png
// module id = XI4y
// module chunks = 1